import { buildRoute } from '@direct-frontend/modules-router';

export const emailAuthRoute = buildRoute('/auth/email');
